import { createContext, useContext, useEffect, useState } from 'react';
import { ForemanNavbarContextData, ForemanNavbarProviderProps } from './types';
import { initialJobRequestsCount } from './constants';

const ForemanNavbarContext = createContext<ForemanNavbarContextData | Record<string, never>>({});

export const ForemanNavbarProvider = ({ children }: ForemanNavbarProviderProps) => {
  const [jobRequestsCount, setJobRequestsCount] = useState<number>(initialJobRequestsCount);

  return (
    <ForemanNavbarContext.Provider value={{ jobRequestsCount, setJobRequestsCount }}>
      {children}
    </ForemanNavbarContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useForemanNavbarContext = () => useContext(ForemanNavbarContext);

export const useSyncJobRequestsCount = (count?: number) => {
  const { setJobRequestsCount } = useForemanNavbarContext();

  useEffect(() => {
    if (count === undefined || !setJobRequestsCount) return;
    setJobRequestsCount(count);
  }, [count, setJobRequestsCount]);
};
